import { render, staticRenderFns } from "./TolAddress.vue?vue&type=template&id=0fa3f961&scoped=true&"
import script from "./TolAddress.vue?vue&type=script&lang=js&"
export * from "./TolAddress.vue?vue&type=script&lang=js&"
import style0 from "./TolAddress.vue?vue&type=style&index=0&id=0fa3f961&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa3f961",
  null
  
)

export default component.exports